import styled from 'styled-components'

export default styled.textarea`
	border-radius: 8px;
	border: 1px solid lightgrey;
	height: 12em;
	line-height: 1.2;
	margin-bottom: 10px;
	outline: none;
	padding: 8px;
	resize: none;
`



// WEBPACK FOOTER //
// ./src/primitives/Textarea.js